import React, { Component } from "react";
import { connect } from "react-redux";
import { REACT_APP_RESOURCE_URL } from "../../shared/vars";

import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// CSS
import "../../css/banners.css";

class Banners extends Component {
	constructor(props) {
		super(props);
		this.settings = {
			arrows: false,
			autoplay: true,
			autoplaySpeed: 6000,
			pauseOnHover: true,
			dots: true,
			infinite: true,
			speed: 500
			// swipeToSlide: true
		};
	}
	showPanoWrapper(item, i) {
		const { href } = item;

		if (href) {
			return (
				<a key={i} href={href} className="pano_main">
					{this.showPicture(item)}
				</a>
			);
		} else {
			return (
				<div key={i} className="pano_main">
					{this.showPicture(item)}
				</div>
			);
		}
	}

	showPicture(item) {
		const { sizes } = item;

		let sourcesFull;
		let imageMobile;
		if (sizes.full) {
			sourcesFull = <source src={REACT_APP_RESOURCE_URL + sizes.full.src} media="(min-width: 500px)" />;
			imageMobile = <img src={REACT_APP_RESOURCE_URL + sizes.full.src} alt={item.alt} />;
		}

		let sourcesMobile;
		if (sizes.mobile) {
			sourcesMobile = <source src={REACT_APP_RESOURCE_URL + sizes.mobile.src} />;
		}

		if (sizes.mobile) {
			imageMobile = <img src={REACT_APP_RESOURCE_URL + sizes.full.src} alt={item.alt} />;
		}

		return (
			<picture>
				{/*<!--[if IE 9]><video style="display: none"><![endif]-->*/}
				{sourcesFull}
				{sourcesMobile}
				{/*<!--[if IE 9]></video><![endif]-->*/}
				{imageMobile}
			</picture>
		);
	}

	showBanners(banner, i) {
		return this.showPanoWrapper(banner, i);
	}

	render() {
		if (this.props.banners.banners) {
			return (
				<Slider {...this.settings}>
					{this.props.banners.banners.map((banner, i) => {
						return this.showBanners(banner, i);
					})}
				</Slider>
			);
		} else {
			return null;
		}
	}
}

const mapStateToProps = state => {
	return {
		banners: state.banners
	};
};

export default connect(mapStateToProps)(Banners);



// WEBPACK FOOTER //
// ./src/components/home/Banners.js